import { Box, Typography, useTheme } from '@mui/material';

import InfoIcon from '../shared/icons/info-icon';

const EstadoJugadoresNoHayJugadores = () => {
    const theme = useTheme();
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
            padding={4}
            textAlign="center"
            bgcolor={theme.palette.background.default}
            borderRadius={2}
            boxShadow={1}
            className="mb-25"
        >
            <InfoIcon fontSize="large" />
            <Typography variant="h6" color={theme.palette.text.secondary} style={{ marginTop: '16px' }}>
                No hay datos disponibles
            </Typography>
            <Typography variant="body2" color={theme.palette.text.secondary} style={{ marginTop: '8px' }}>
                Parece que no hay información para mostrar en este momento.
            </Typography>
        </Box>
    );
};

export default EstadoJugadoresNoHayJugadores;
